const instances = {};

export function get(name) {
  return instances[name];
}

export function set(name, instance) {
  instances[name] = instance;
}



/** WEBPACK FOOTER **
 ** ./legacy/home24/helpers/tracking-instances.js
 **/